export const translations = {
  nav: {
    home: 'Home',
    about: 'About',
    destinations: 'Destinations',
    contact: 'Contact',
    resources: 'Resources',
  },
  hero: {
    tagline: 'Crafting Unforgettable Moments Across Mexico',
    subheading: 'Effortless, elegant, and unforgettable celebrations in Mexico\'s most breathtaking destinations.',
    trusted: '',
  },
  cta: {
    begin: 'Begin your journey',
    seeDestinations: 'See destinations',
    exploreVenue: 'Explore Venue',
    readyToBegin: 'Ready to begin your journey?',
    scheduleConsultation: 'Schedule a Consultation',
    consultationDetails: '30-minute complimentary consultation\nEnglish and Spanish available',
    stayInspired: 'Stay Inspired',
    signUpForNewsletter: 'Subscribe to our newsletter for exclusive inspiration, planning tips, and featured destinations.',
    subscribe: 'Subscribe',
    meetYourPlanners: 'Meet Your Planners',
  },
  about: {
    heroTitle: 'Assemblage',
    heroSubtitle: 'Crafted for the Extraordinary',
    heroDescription: 'We create once-in-a-lifetime celebrations for couples who expect the extraordinary.',
    philosophyTitle: 'Our Philosophy',
    philosophyText: 'At Assemblage, we believe your wedding should be a true reflection of your story—elegant, effortless, and unforgettable. Our team brings years of expertise, insider access to Mexico\'s most exclusive venues, and a commitment to excellence that sets us apart.',
    founder: 'Founder',
    whyAssemblage: 'Why Assemblage?',
    belief: 'At Assemblage, we believe your wedding should be a true reflection of your story—elegant, effortless, and unforgettable. Our team brings years of expertise, insider access to Mexico\'s most exclusive venues, and a commitment to excellence that sets us apart.',
  },
  contact: {
    heroTitle: 'Let\'s Begin Your Assemblage Celebration',
    heroDescription: 'Share your vision. We\'ll handle the extraordinary.',
    firstName: 'First Name*',
    lastName: 'Last Name*',
    name: 'Name*',
    email: 'Email*',
    whatsapp: 'WhatsApp Number',
    country: 'Country',
    languagePreference: 'Preferred Language',
    guestCount: 'Number of Guests',
    budgetRange: 'Budget Range',
    eventDate: 'Event Date',
    location: 'Preferred Location',
    notes: 'Tell us your vision',
    requestConsultation: 'Request Consultation',
    sending: 'Sending...',
    success: 'Thank you! We will be in touch soon.',
    error: 'There was an error. Please try again.',
    preferCall: 'Prefer to book a call?',
    bookCalendly: 'Book via Calendly',
    contactUs: 'Contact us:',
    title: 'Contact Us',
    subtitle: 'Begin Your Journey',
    formHeaderTitle: 'Begin Your Journey',
    formHeaderSubtitle: 'Share your vision below, and our expert planners will be in touch to bring your celebration to life.',
  },
  destinations: {
    title: 'Our Destinations',
    viewAll: 'Handpicked venues for the most discerning couples.',
    curatedDestinations: 'Curated Destinations',
    customLocation: 'Custom Location',
    customLocationDesc: 'Have a specific location in mind?',
    notFound: 'Destination Not Found',
    backToDestinations: 'Back to Destinations',
    about: 'About',
    bestTimeToVisit: 'Best Time to Visit',
    diningOptions: 'Dining Options',
    diningDescription: 'A top dining experience in {destination} featuring local and international cuisine.',
    activitiesIn: 'Activities in',
    activity: 'Activity',
    activityDescription: 'Discover one of the top experiences in {destination}.',
    featuredVenues: 'Featured Venues',
    venue: 'Venue',
    exploreOnMap: 'Explore',
    localTouch: 'A Local Touch',
    bookConsultation: 'Book a Destination Consultation',
  },
  experience: {
    theAssemblageExperience: 'The Assemblage Experience',
    AssemblageDesign: 'Inspired by Your Unique Story',
    AssemblageDesignText: 'We listen to every wish, transforming your dreams into a celebration that feels authentically and uniquely yours.',
    localExpertise: 'Insider Access',
    localExpertiseText: "Gain entry to Mexico's most exclusive venues and hidden gems, reserved for Assemblage couples.",
    seamlessPlanning: 'Signature Touches',
    seamlessPlanningText: 'From custom-designed experiences to thoughtful guest surprises, we infuse your event with unforgettable moments.',
    memories: 'Effortless Enjoyment',
    memoriesText: 'Relax and savor every second—our team orchestrates every element so you can be fully present with your loved ones.'
  },
  testimonials: {
    loveStories: 'Love Stories',
  },
  footer: {
    AssemblageBodas: 'Assemblage Bodas',
    about: 'About',
    destinations: 'Destinations',
    contact: 'Contact',
    email: 'Email',
    whatsApp: 'WhatsApp',
    instagram: 'Instagram',
    allRightsReserved: 'All rights reserved.',
    partner: 'Become an Assemblage Partner',
  },
  destinationDetail: {
    brandIntro: {
      tagline: "Where dreams become unforgettable moments",
      title: "Crafting Your Perfect Mexican Wedding",
      description: "At Assemblage, we believe that every love story deserves a celebration as unique as the couple themselves. Our deep-rooted connection to Mexico's most enchanting destinations allows us to create weddings that are not just events, but unforgettable experiences.",
      promiseTitle: "Our Promise",
      promiseText: "We combine local expertise with international standards to create celebrations that are both authentic and extraordinary.",
      approachTitle: "Our Approach",
      approachText: "Every detail is thoughtfully curated to reflect your unique vision while embracing the rich cultural tapestry of Mexico.",
      learnMore: "Learn more about our story"
    },
    why: {
      title: "Why Choose {destination}?",
      magicTitle: "Experience the Magic of {destination}",
      climate: "Climate & Seasons",
      accessibility: "Seamless Accessibility"
    },
    venues: {
      title: "Dream Venues in {destination}",
      blurb: "Beyond the iconic, our curated portfolio includes exclusive access to private estates and unique venues, ensuring a truly distinct backdrop in {destination}.",
      explore: "Explore Venues with Us"
    },
    experiences: {
      title: "Guest Experiences in {destination}",
      blurbDefault: "From golden sunsets on the bay to private art walks through vibrant streets,",
      blurb: "Every moment in {destination} is designed to delight your guests. Let us craft a journey where adventure, culture, and celebration blend seamlessly—leaving your loved ones with memories as unforgettable as your wedding day.",
      curated: "Curated Guest Journeys"
    },
    budget: {
      title: "Crafting Your {destination} Wedding Budget",
      selected: "Your selected budget:",
      for: "for",
      default: "(default)",
      perGuest: "Cost per guest:",
      reset: "Reset to Default",
      total: "Total Estimate",
      estimate: "This is an estimated allocation based on your selected budget and guest count. Actual costs may vary based on your preferences and vendor selection.",
      quote: "Request a Personalized Quote",
      allocations: "These allocations are based on typical wedding budgets. We can customize your plan to fit your vision and priorities.",
      planning: "Our comprehensive planning ensures you avoid unforeseen expenses, with all taxes, service charges, and permit fees clearly outlined from the outset."
    },
    vendor: {
      title: "Vendor Network & Collaboration",
      text: "Our established relationships with {destination}'s most esteemed vendors mean unparalleled quality and a proven track record, ensuring a seamless collaborative process for co-planners."
    },
    faq: {
      title: "FAQs for Your Wedding in Mexico",
      q1: "What is the best time of year to get married in this destination?",
      a1: "The ideal time depends on your preferences. Spring (March-May) and Fall (September-November) offer perfect weather with comfortable temperatures. Summer can be hot but offers lower rates, while winter provides a magical atmosphere with holiday decorations.",
      q2: "How far in advance should we book our wedding?",
      a2: "We recommend booking 12-18 months in advance, especially for peak season dates. This ensures availability of preferred venues and vendors, and allows time for proper planning and coordination.",
      q3: "What are the legal requirements for getting married in Mexico?",
      a3: "Navigating Mexico's legal requirements for international weddings can be complex. Our in-house experts handle all documentation and coordination for civil and religious ceremonies, providing absolute peace of mind. For a legal ceremony, you'll need valid passports, birth certificates, and proof of single status. We handle all documentation and coordinate with local authorities to ensure a smooth process.",
      q4: "Can you help with guest accommodations and transportation?",
      a4: "Absolutely! We work with a curated selection of hotels and transportation services to create special group rates and seamless logistics for your guests.",
      q5: "What happens if it rains on our wedding day?",
      a5: "All our venues have beautiful indoor alternatives, and we always have a backup plan. We monitor weather forecasts closely and make necessary adjustments to ensure your day is perfect.",
      q6: "Do you offer partial planning services?",
      a6: "Yes, we offer various planning packages from full-service to day-of coordination. We can customize our services to match your needs and budget.",
      q7: "What languages do you work in?",
      a7: "Our team is fluent in English, Spanish, and several other languages. We ensure clear communication with all vendors and guests throughout the planning process.",
      q8: "How do you handle dietary restrictions?",
      a8: "We work closely with our catering partners to accommodate all dietary requirements. From vegetarian and vegan options to specific allergies, we ensure all guests are well taken care of."
    },
    cta: {
      title: "Ready to Plan Your Dream Wedding in {destination}?",
      schedule: "Schedule Your Free Consultation",
      whatsapp: "WhatsApp"
    },
    accommodation: {
      title: "Hotels, Resorts & Stays",
      description: "Discover our carefully curated selection of accommodations, from luxury resorts to boutique hotels, ensuring your guests experience the perfect blend of comfort and local charm.",
      blurb: "Each property has been personally vetted to ensure exceptional service, stunning views, and the perfect setting for your celebration."
    },
    dining: {
      title: "Dining Experiences",
      description: "From beachfront restaurants to rooftop venues, experience the finest culinary offerings that showcase the rich flavors and traditions of Mexico.",
      blurb: "Our partnerships with top chefs and restaurants ensure an unforgettable dining experience for you and your guests."
    },
  },
  resources: {
    pageTitle: 'Resources',
    pageDescription: 'Everything you need to plan your perfect destination wedding in Mexico.',
    faqTitle: 'FAQs',
    faqDescription: 'Find answers to common questions about destination weddings in Mexico.',
    topVenuesTitle: 'Top 10 Venues in Mexico',
    topVenuesDescription: 'Discover the most stunning and unique wedding venues across Mexico.',
    destinationGuidesTitle: 'Destination Guides',
    destinationGuidesDescription: 'Explore our comprehensive guides to Mexico\'s most popular wedding destinations.',
    ctaTitle: 'Ready to Start Planning Your Dream Wedding?',
    ctaDescription: 'Let us help you create the perfect destination wedding experience in Mexico.',
    ctaButton: 'Get Started',
    topVenuesHeroTitle: 'The 10 Best Wedding Venues in Mexico',
    topVenuesIntro1: 'Mexico is renowned for its warmth, breathtaking scenery, and sophisticated hospitality. For couples seeking a once-in-a-lifetime celebration, these ten venues are the gold standard—each offering its own unique blend of exclusivity, beauty, and flawless service. From pristine beaches to historic cities, this list is your ultimate guide to the country\'s best.',
    topVenuesIntro2: 'Each of these venues offers a unique blend of luxury, romance, and authentic Mexican charm. Whether you\'re drawn to the turquoise waters of the Caribbean, the dramatic cliffs of Los Cabos, or the colonial elegance of Mexico\'s historic cities, these venues promise to transform your wedding into an unforgettable celebration. With world-class service, stunning settings, and attention to every detail, your special day will be nothing short of magical.',
    whyWeLoveIt: 'Why we love it:',
    ratingLabel: 'Rating:',
    topVenuesOutro: 'Still searching for "the one"? Let us know your vision—there\'s a dream venue in Mexico for every couple and every story.',
    aboutAssemblageTitle: 'About Assemblage',
    aboutAssemblageDesc: 'We\'re a boutique wedding planning company specializing in luxury destination weddings in Mexico. Our team of experienced planners ensures every detail is perfect.',
    learnMore: 'Learn more about us',
    readyToFindVenue: 'Ready to find your perfect venue?',
    ourPlannersHelp: 'Our expert planners can help you discover and secure the ideal location for your dream wedding.',
    scheduleConsultation: 'Schedule a Consultation'
  },
  faq: {
    pageTitle: 'Frequently Asked Questions',
    pageDescription: 'Find answers to the most common questions about destination weddings in Mexico, planning, and working with Assemblage.',
    foreignerTab: 'International Couples',
    domesticTab: 'Mexican Couples',
    foreignerQuestions: [
      { q: 'Why choose Assemblage over a resort wedding planner package?', a: 'Assemblage offers truly personalized, boutique planning with access to the best venues, vendors, and experiences across Mexico—not just one resort. We advocate for your vision, negotiate on your behalf, and provide creative, unbiased guidance. Resort planners are limited to their property and may have divided loyalties, while Assemblage is dedicated solely to you and your celebration.' },
      { q: 'Can foreigners legally get married in Mexico?', a: 'Yes, foreigners can legally marry in Mexico. We help you with all the paperwork and requirements.' },
      { q: 'What documents do we need for a legal wedding in Mexico?', a: 'You will need valid passports, birth certificates, and proof of single status. We guide you through the process.' },
      { q: 'Is our marriage valid in our home country?', a: 'Yes, as long as you follow the legal process in Mexico, your marriage will be recognized internationally.' },
      { q: 'Do we need to be in Mexico for a certain number of days before the wedding?', a: 'Some regions require you to be in Mexico for a few days before the ceremony. We will advise you based on your destination.' },
      { q: 'Can we have a symbolic ceremony instead of a legal one?', a: 'Absolutely! Many couples choose a symbolic ceremony for ease and flexibility, then handle the legal paperwork at home.' },
      { q: 'What language will the ceremony be in?', a: 'Ceremonies can be performed in English, Spanish, or both. We provide bilingual officiants if needed.' },
      { q: 'Do we need to translate our documents?', a: 'Some documents may require official translation into Spanish. We will let you know exactly what is needed.' },
      { q: 'Any travel tips for our guests?', a: 'We recommend booking flights and accommodations early, and we can help with group rates and travel logistics.' },
      { q: 'What should our international guests know about traveling to Mexico?', a: 'We recommend guests check passport validity, visa requirements, and travel advisories for Mexico. We can provide invitation letters if needed for visa applications.' },
      { q: 'Are there direct flights to the wedding destination?', a: 'Most major destinations in Mexico are served by direct flights from the US, Canada, and Europe. We can help recommend the best routes and airports.' },
      { q: 'Is airport transportation provided for guests?', a: 'We can arrange group transfers or recommend reliable transportation options from the airport to your hotel or venue.' },
      { q: 'What about health and safety for international guests?', a: 'We provide up-to-date information on health and safety, including travel insurance, recommended vaccinations, and local emergency contacts.' },
      { q: 'Can you help with group hotel rates for our guests?', a: 'Yes! We negotiate group rates and can help coordinate room blocks for your guests at recommended hotels.' }
    ],
    domesticQuestions: [
      { q: 'Why choose Assemblage over a resort wedding planner package?', a: 'Assemblage offers truly personalized, boutique planning with access to the best venues, vendors, and experiences across Mexico—not just one resort. We advocate for your vision, negotiate on your behalf, and provide creative, unbiased guidance. Resort planners are limited to their property and may have divided loyalties, while Assemblage is dedicated solely to you and your celebration.' },
      { q: 'Can Mexican citizens get married in a different state?', a: 'Yes, Mexican citizens can marry in any state. We help with the paperwork and local requirements.' },
      { q: 'What documents do Mexican citizens need for a wedding?', a: 'You will need your birth certificate, official ID, and proof of single status. We assist with all details.' },
      { q: 'Can we have a religious and civil ceremony?', a: 'Yes, you can have both. We coordinate with local authorities and religious institutions.' },
      { q: 'Do you offer planning for local couples?', a: 'Absolutely! We offer full planning services for both local and destination weddings.' },
      { q: 'Can we have a symbolic ceremony?', a: 'Yes, symbolic ceremonies are popular and can be customized to your preferences.' },
      { q: 'Can our ceremony be bilingual?', a: 'Of course! We can arrange for bilingual officiants and materials.' },
      { q: 'Do we need to translate any documents?', a: 'If any documents are from abroad, they may need to be translated. We will advise you.' },
      { q: 'What should our guests know about traveling within Mexico?', a: 'We provide travel tips, group rates, and local recommendations for your guests.' }
    ],
    questions: [
      { q: 'What is the best time of year to get married in Mexico?', a: 'Spring (March-May) and Fall (September-November) offer perfect weather. Summer is warmer but offers lower rates, and winter is magical with festive decor.' },
      { q: 'How far in advance should we book our wedding?', a: 'We recommend booking 12-18 months in advance, especially for popular dates and venues.' },
      { q: 'Can you help with legal requirements for getting married in Mexico?', a: 'Yes! Our team handles all documentation and coordination for civil and religious ceremonies.' },
      { q: 'Do you offer partial planning or day-of coordination?', a: 'Yes, we offer a range of planning packages to suit your needs.' },
      { q: 'Can you help with guest accommodations and transportation?', a: 'Absolutely! We work with top hotels and transportation providers to ensure a seamless experience for your guests.' },
      { q: 'What languages do you work in?', a: 'Our team is fluent in English, Spanish, and more. We ensure clear communication with all vendors and guests.' },
      { q: 'How do you handle dietary restrictions?', a: 'We work closely with our catering partners to accommodate all dietary requirements.' }
    ]
  },
}; 